import React, {useCallback, useContext, useState} from 'react';
import {Chevron} from '@jutro/components';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {IntlContext, TranslatorContext} from '@jutro/locale';
import {ViewModelForm} from 'gw-portals-viewmodel-react';
import VehicleCoverage from './VehicleCoverage/VehicleCoverage';
import metadata from './PolicyVehiclesDriversInfo.metadata.json5';
import styles from '../../Summary.module.scss';
import infostyles from './PolicyVehiclesDriversInfo.module.scss';
import messages from '../../Summary.messages';
import { NumberValue} from "@jutro/components";
import DiscountSurchargesDisplayComponent
    from '../../../../Components/DiscountSurchargesDisplayComponent/DiscountSurchargesDisplayComponent';
import DiscountComponent
    from '../../../../Components/DiscountSurchargesDisplayComponent/DiscountSurchargesDisplayComponent';

//~ Vehicle type classes
class PrivatePassengerVehicle {
    constructor() {
    }
    generateVehicleOverrides = (value, index) => {
        const overrides = {
            [`dailyCommuteKM${index}`]: {
                visible: value.primaryUse === 'Commute' || value.primaryUse === 'Business'
            },
            [`businessPercentage${index}`]: {
                visible: value.primaryUse === 'Business'
            }
        }
        return Object.assign({}, overrides);
    }
}

class MotorCycle extends PrivatePassengerVehicle {
    constructor() {
        super();
    }
    generateVehicleOverrides = (value, index) => {
        const overrides = {
            [`engineDisplacement${index}`]: {
                visible: true
            },
            [`dailyCommuteKM${index}`]: {
                visible: value.primaryUse === 'Commute' || value.primaryUse === 'Business'
            },
            [`businessPercentage${index}`]: {
                visible: value.primaryUse === 'Business'
            }
            // ...super.generateVehicleOverrides(value, index)

        }
        return Object.assign({}, overrides);
    }

}

class SnowVehicle extends PrivatePassengerVehicle {
    constructor() {
        super();
    }
    generateVehicleOverrides = (value, index) => {
        const overrides = {
            [`dailyCommuteKM${index}`]: {
                visible: value.primaryUse === 'Commute' || value.primaryUse === 'Business'
            },
            [`businessPercentage${index}`]: {
                visible: value.primaryUse === 'Business'
            },
            [`engineDisplacement${index}`]: {
                visible: true
            },
            [`engineType${index}`]: {
                visible: true
            },
            // ...super.generateVehicleOverrides(value, index)
        }
        return Object.assign({}, overrides);
    }
}

class AntiqueAndClassic extends PrivatePassengerVehicle {
    constructor() {
        super()
    }
    generateVehicleOverrides = (value, index) => {
        const overrides = {
            [`dailyCommuteKM${index}`]: {
                visible: value.primaryUse === 'Commute' || value.primaryUse === 'Business'
            },
            [`businessPercentage${index}`]: {
                visible: value.primaryUse === 'Business'
            },
            [`vehicleAppraisalDate${index}`]: {
                visible: true
            },
            [`vehicleAppraisalAmount${index}`]: {
                visible: true
            },
            //TODO: super class call is not working :(
            // ...super.generateVehicleOverrides(value, index)
        }
        return Object.assign({}, overrides);
    }
}

class PrivatePassengerTrailer extends PrivatePassengerVehicle {
    constructor() {
        super()
    }
    generateVehicleOverrides = (value, index) => {
        const overrides = {
            [`dailyCommuteKM${index}`]: {
                visible: value.primaryUse === 'Commute' || value.primaryUse === 'Business'
            },
            [`businessPercentage${index}`]: {
                visible: value.primaryUse === 'Business'
            },
            [`trailerType${index}`]: {
                visible: true
            },
            // ...super.generateVehicleOverrides(value, index)
        }
        return Object.assign({}, overrides);
    }
}

class AllTerrainVehicle extends PrivatePassengerVehicle {
    constructor() {
        super()
    }
    generateVehicleOverrides = (value, index) => {
        const overrides = {
            [`dailyCommuteKM${index}`]: {
                visible: value.primaryUse === 'Commute' || value.primaryUse === 'Business'
            },
            [`businessPercentage${index}`]: {
                visible: value.primaryUse === 'Business'
            },
            [`engineDisplacement${index}`]: {
                visible: true
            },
            [`bodyStyle${index}`]: {
                visible: true
            },
            [`numberOfWheels${index}`]: {
                visible: true
            },
            // ...super.generateVehicleOverrides(value, index)
        }
        return Object.assign({}, overrides);
    }
}

class CommercialVehicleTrailer extends PrivatePassengerVehicle {
    constructor() {
        super()
    }
    generateVehicleOverrides = (value, index) => {
        const overrides = {
            [`dailyCommuteKM${index}`]: {
                visible: value.primaryUse === 'Commute' || value.primaryUse === 'Business'
            },
            [`businessPercentage${index}`]: {
                visible: value.primaryUse === 'Business'
            },
            [`trailerSupplement${index}`]: {
                visible: true
            },
            [`carryingCapacity${index}`]: {
                visible: true
            },

            //...super.generateVehicleOverrides(value, index)
        }
        return Object.assign({}, overrides);
    }
}

class FarmBus extends PrivatePassengerVehicle {
    constructor() {
        super()
    }
    generateVehicleOverrides = (value, index) => {
        const overrides = {
            [`dailyCommuteKM${index}`]: {
                visible: value.primaryUse === 'Commute' || value.primaryUse === 'Business'
            },
            [`businessPercentage${index}`]: {
                visible: value.primaryUse === 'Business'
            },
            [`noOfSeats${index}`]: {
                visible: true
            },
            // ... super.generateVehicleOverrides(value, index)
        }
        return Object.assign({}, overrides);
    }
}

class FuneralDirector extends PrivatePassengerVehicle {
    constructor() {
        super()
    }
    generateVehicleOverrides = (value, index) => {
        const overrides = {
            [`dailyCommuteKM${index}`]: {
                visible: value.primaryUse === 'Commute' || value.primaryUse === 'Business'
            },
            [`businessPercentage${index}`]: {
                visible: value.primaryUse === 'Business'
            },
            [`funeralDirectorVehicleType${index}`]: {
                visible: true
            },
            //...super.generateVehicleOverrides(value, index)
        }
        return Object.assign({}, overrides);
    }
}

class CommercialVehicle extends PrivatePassengerVehicle {
    constructor() {
        super()
    }
    generateVehicleOverrides = (value, index, translator, isPolicyInfoPage) => {
        const overrides = {
            [`dailyCommuteKM${index}`]: {
                visible: value.primaryUse === 'Commute' || value.primaryUse === 'Business'
            },
            [`businessPercentage${index}`]: {
                visible: value.primaryUse === 'Business'
            },
            [`classOfUse${index}`]:{
                visible: false
            },
            [`commericalVehicleSupplementSection${index}`]: {
                visible: true
            },
            [`covrDetailsSection${index}`]: {
                visible: true
            },
            [`cvsHaulNonOwnedTrailers${index}`]: {
                value: isPolicyInfoPage ?  (value.haulNonOwnedTrailers_EY == true ? 'Yes' : 'No') : value.haulNonOwnedTrailers
            },
            [`cvsSeasonalDelivery${index}`]: {
                value: isPolicyInfoPage ?  (value.seasonalDelivery_EY == true ? 'Yes' : 'No') : value.seasonalDelivery
            },
            [`cvsRadiusOfOperations${index}`]: {
                value: isPolicyInfoPage ? ( 
                    _.isUndefined(value.distanceRadiusNonHorseFilter) ? '-' : translator({'id': `typekey.DistanceRadius_EY.${value.distanceRadiusNonHorseFilter}`})) : value.radiusOfOperations
            },
            [`cvsUseOfVehicle${index}`]: {
                value: isPolicyInfoPage ? translator({'id': `typekey.UseOfVehicle_EY.${value.useOfVehicle_EY}`}) : value.useOfVehicle
            },
            [`cvsDelivery${index}`]: {
                value: isPolicyInfoPage ? translator({'id': `typekey.Delivery_EY.${value.delivery_EY}`}) : value.delivery
            },
            [`CVORNumber${index}`]: {
                value: isPolicyInfoPage ?  value.cvorNumber_EY : value.cvornumber
            },
            [`CVORRating${index}`]: {
                value: isPolicyInfoPage ?  value.covrRating_EY : value.cvorrating 
            },
            [`CVORViolationRate${index}`]: {
                value: isPolicyInfoPage ?  value.covrViolationRate_EY : value.cvorviolationRate 
            },
            [`CVORReportDate${index}`]: {
                value: isPolicyInfoPage ?  value.covrReportDate_EY : value.cvorreportDate
            },
            [`CVORReOrderDate${index}`]: {
                value: isPolicyInfoPage ?  value.covrReOrderDate_EY : value.cvorreOrderDate 
            }

            //...super.generateVehicleOverrides(value, index)
        }
        return Object.assign({}, overrides);
    }
}


const getHeaderSection = (title) => {
    return (isOpen) => (
        <React.Fragment>
            <Chevron isOpen={isOpen} align="right" className={styles.chevronStyle} />
            <h2 className={`${styles.title} ${styles.gwOverrideDefaultMargin}`}>{title}</h2>
        </React.Fragment>
    );
};

//Pass the location on the 2nd parameter
const getVehicleHeaderSection = (title, title1) => {
    return (isOpen) => (
        <React.Fragment>
            <Chevron isOpen={isOpen} align="right" className={styles.chevronStyle} />
            <h2 className={`${styles.title} ${styles.gwOverrideDefaultMargin}`}>{title}</h2>
            <h3 className={`${styles.title1} ${styles.gwOverrideDefaultMargin}`}>{title1}</h3>
        </React.Fragment>
    );
};

const getHeaderName = (vehicle, count) => {
     //var headerName = 'Vehicle # ' + count;
     var headerName = 'Vehicle # ';
     headerName += (vehicle.vehicleNumber ? vehicle.vehicleNumber + ' ' : '');
     headerName += (vehicle.make || vehicle.model) ? ': ' : '';
     headerName += vehicle.year ? vehicle.year + ' ' : '';
     headerName += vehicle.make ? vehicle.make + ' ' : '';
     headerName += vehicle.model ? vehicle.model : '';
     return headerName;
};


function getCell(items, index, property) {
    const value = _.get(items, property.path);
    if(property.id == 'premium'){
        return (
            <b>{
                value ?
                    <NumberValue
                        format="decimal"
                        id={`premium_${index}`}
                        maximumFractionDigits={2}
                        placeholder="-"
                        showFractions
                        suffix=".00"
                        tag="span"
                        value={value}
                    />
                    :
                    <span>-</span>
            }
            </b>
         );
    }
    return <span>{value || ''}</span>
}

function PolicyVehiclesDriversInfo({ value, isPolicyInfoPage }) {
    const translator = useContext(TranslatorContext);
    const intl = useContext(IntlContext);
    const currencyFormatter = Intl.NumberFormat("en-CA", {style: "currency", currency: "CAD"});
    //~ Vehicle type and its class registration
    const vehicleClassRegister = new Map();

    vehicleClassRegister.set('Private Passenger Vehicle', new PrivatePassengerVehicle());
    vehicleClassRegister.set('Motorcycle', new MotorCycle());
    vehicleClassRegister.set('Motor Home', new PrivatePassengerVehicle());
    vehicleClassRegister.set('Snow Vehicle', new SnowVehicle());
    vehicleClassRegister.set('Classic Vehicle', new AntiqueAndClassic());
    vehicleClassRegister.set('Antique Vehicle', new AntiqueAndClassic());
    vehicleClassRegister.set('Private Passenger Trailer', new PrivatePassengerTrailer());
    vehicleClassRegister.set('All Terrain Vehicle (ATV)', new AllTerrainVehicle());
    vehicleClassRegister.set('Commercial Vehicle - Trailer', new CommercialVehicleTrailer());
    vehicleClassRegister.set('Farm Bus', new FarmBus());
    vehicleClassRegister.set('Funeral Director', new FuneralDirector());
    vehicleClassRegister.set('Commercial Vehicle', new CommercialVehicle());


    const [openItems, setOpenItems] = useState([]);
    if (_.isEmpty(value.vehicleDTOs)) {
        return null;
    }

    const vehicleDTOs = value.vehicleDTOs;

    const readValue = useCallback(
        (id, path) => {
            if (path === 'vehicleDTOs') {
                return vehicleDTOs;
            }
            return _.get(vehicleDTOs, path);
        },
        [vehicleDTOs]
    );

    const getDriverCoverageData = () => {
        const driverData = value.driverDTOs;
        return driverData
            .map((driver) => {
                return {
                    driverName: driver.displayName,
                    licenseNumber: driver.licenseNumber,
                    dateOfBirth: intl.formatDate(
                        new Date(
                            driver.dateOfBirth.year,
                            driver.dateOfBirth.month,
                            driver.dateOfBirth.day
                        ), { year: 'numeric', month: 'short', day: 'numeric' }
                    )
                };
            })
            .sort((a, b) => {
                return a.driverName - b.driverName;
            });
    };

    // const getLimitDeductableValue = (terms, type) => {
    //     if (!_.isEmpty(terms) && (terms[0].modelType === type || terms[0].name === type)) {
    //         return terms[0].amount || terms[0].chosenTermValue;
    //     }
    //     return '-';
    // };

    const getLimitDeductableValue = (terms, type) => {
        const exceptionLimitNames = ['Non-catastrophic limit', 'Spouse'];
        if (!_.isEmpty(terms) && (terms[0].modelType === type || terms[0].name === type
            || (exceptionLimitNames.includes(terms[0].name) && type == 'Limit'))) {
            return terms[0].amount || terms[0].chosenTermValue;
        }
        return '-';
    };

    const getCoverage = (coverages, isLineCoverage) => {
        return coverages.map((coverage) => {
            return {
                name: coverage.name,
                coverageType: isLineCoverage ? translator(messages.vehicleInfoPolicy) : null,
                driverType: coverage.driverType,
                limit: getLimitDeductableValue(coverage.terms, 'Limit'),
                deductible: getLimitDeductableValue(coverage.terms, 'Deductible'),
                premium: coverage.premium
            };
        });
    };
    const lineCoverage = getCoverage(value.coverageDTOs, true);
    const toggleShowHide = (item) => {
        const openedItem = _.clone(openItems);
        const index = _.indexOf(openedItem, item);
        if (index === -1) {
            openedItem.push(item);
            setOpenItems(openedItem);
        } else {
            setOpenItems(_.slice(openedItem, index, 0));
        }
    };

    const getVehicleFieldOverride = (vehicleDTO, index) => {
      const translator = useContext(TranslatorContext);
      const klass = vehicleClassRegister.get(vehicleDTO.vehicleTypeName);
      return  klass.generateVehicleOverrides(vehicleDTO, index, translator, isPolicyInfoPage);
    }
    const generateVehicleOverrides = () => {
        const overrides = value.vehicleDTOs.map((vehicleDTO, index) => {
            const vehicleCoverage = getCoverage(vehicleDTO.coverages);
            let count = index + 1;
            var headName = getHeaderName(vehicleDTO, count);

            return {
                [`vehicleCoverageInfo${index}`]: {
                    data: _.concat(lineCoverage, vehicleCoverage),
                    show: openItems
                },
                [`policyDiscounts${index}`]: {
                    visible: (vehicleDTO.discounts && vehicleDTO.discounts.length > 0) || !!(vehicleDTO.ey_Discounts && vehicleDTO.ey_Discounts.length > 0),
                    data: (vehicleDTO.discounts && vehicleDTO.discounts.length > 0) ? vehicleDTO.discounts : ((vehicleDTO.ey_Discounts && vehicleDTO.ey_Discounts.length > 0) ? vehicleDTO.ey_Discounts : [])
                },
                [`showContentToggleLink${index}`]: {
                    onClick: () => toggleShowHide(index)
                },
                [`contentDetailToggle${index}`]: {
                    icon: _.includes(openItems, index) ? 'caret-up' : 'caret-down',
                    message: _.includes(openItems, index)
                        ? translator(messages.hideVehicleCoverages)
                        : translator(messages.showVehicleCoverages)
                },
                [`vehicleCoverageContainer${index}`]: {
                    visible: _.includes(openItems, index)
                },
                [`vehicleSection${index}`]: {
                    header: vehicleDTO.premium && vehicleDTO.premium.amount ? getVehicleHeaderSection(headName, `Premium ${ currencyFormatter.format(vehicleDTO.premium.amount)}` ):getVehicleHeaderSection(headName, 'Vehicle Premium$' ),
                    cardHeadingClassName: isPolicyInfoPage ? 'cardHeadingClassName' : '',
                    cardBodyClassName: isPolicyInfoPage ? 'cardBodyClassName' : 'gwVehicleCoverages',
                },
                [`driverAssignmentInfo${index}`]: {
                    data: vehicleDTO.drivers
                },
                [`driverAssignmentSection${index}`]: {
                    visible: vehicleDTO.drivers?.length > 0
                },
                [`vehPanel${index}`]:{
                    className: isPolicyInfoPage ? 'headerBoxShadow gwCoveragesContainer' : 'gwCoveragesContainer'
                },
                [`occClassOfUse${index}`]:{
                    visible: !!vehicleDTO.occClassOfUse
                },
                [`occDrivingRecord${index}`]:{
                    visible: !!vehicleDTO.occDrivingRecord
                },
               ...getVehicleFieldOverride(vehicleDTO, index)
            };
        });

        return Object.assign({}, ...overrides);
    };
    const overrides = {
        '@field': {
            // apply to all fields
            //labelPosition: 'top'
            showRequired: true
        },
        driverSection: {
            header: getHeaderSection(translator(messages.coveredDrivers))
        },
        driverCoverageInfo: {
            data: getDriverCoverageData()
        },
        policyPersonalAutoContainer: {
            className: isPolicyInfoPage ? 'gwCoveragesContainerPolicyInfo' : 'gwCoveragesContainer'
        },
        ...generateVehicleOverrides()
    };
    const resolvers = {
        resolveClassNameMap: infostyles,
        resolveCallbackMap: {
            getCellCoverage: getCell
        },
        resolveComponentMap: {
            vehiclecoverage: VehicleCoverage,
            discountscomponent: DiscountSurchargesDisplayComponent
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={value}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

PolicyVehiclesDriversInfo.propTypes = {
    value: PropTypes.shape({
        coverageDTOs: PropTypes.shape([]),
        vehicleDTOs: PropTypes.shape([]),
        driverDTOs: PropTypes.shape([]),
        additionalLiabilityCoverages: PropTypes.shape([]),
        additionalPropertyCoverages: PropTypes.shape([])
    }).isRequired
};
export default PolicyVehiclesDriversInfo;
